import { BaseAction } from "../../../core/actions/BaseAction";
import { getSearchSelectedPassenger } from "../../../Lib/Utils/passenger";
import stopManager from "../../../Lib/Utils/StopManager";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchRequestType, SearchStateType } from "../../../Orchestrator/Types/Index";
import dayjs, { Dayjs } from "dayjs";

type ResumeSearchParams =
    | (SearchRequestType)
    | { search: SearchStateType; storeLocally?: boolean };

export class UpdateSearchDataForResumeAction extends BaseAction<void, ResumeSearchParams> {

    override async run(): Promise<void | null> {
        try {
            const params = this.params!;

            // Handle case where only search object is passed
            if ('search' in params && params.search) {
                const { search, storeLocally = false } = params;

                updateRecoilState("searchStateAtom", {
                    from: search.from,
                    fromName: search.fromName,
                    to: search.to,
                    toName: search.toName,
                    passengers: search.passengers,
                    outboundDate: search.outboundDate,
                    inboundDate: search.inboundDate,
                    fromfmlmSearch: search.fromfmlmSearch,
                    tofmlmSearch: search.tofmlmSearch,
                    fromGeoPosition: search.fromGeoPosition,
                    toGeoPosition: search.toGeoPosition,
                    fromShuttle: search.fromShuttle || false,
                    toShuttle: search.toShuttle || false,
                });

                // Store Last Search Object for "Resume Search"
                if (storeLocally) {
                    const { totalPassengerCount } = getSearchSelectedPassenger(search.passengers);
                    const searchDataForStorage = {
                        origin: search.fromName,
                        destination: search.toName,
                        departureTime: search.outboundDate?.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                        arrivalTime: search.inboundDate?.format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                        passengerCounts: search.passengers,
                        totalPassengerCount: totalPassengerCount,
                        fromShuttle: search.fromShuttle,
                        toShuttle: search.toShuttle,
                        fromfmlmSearch: search.fromfmlmSearch,
                        tofmlmSearch: search.tofmlmSearch,
                        fromGeoPosition: search.fromGeoPosition,
                        toGeoPosition: search.toGeoPosition,
                    };

                    localStorage.setItem("resumeSearch", JSON.stringify(searchDataForStorage));
                }

                return;
            }

            // Handle case where SearchRequestType is passed
            const { origin, destination, passengerCounts, departureTime, arrivalTime, intl, fromShuttle, toShuttle } = params as SearchRequestType;

            if (origin && destination) {
                updateRecoilState("searchStateAtom", {
                    from: origin,
                    fromName: stopManager.getStopNameById(origin),
                    to: destination,
                    toName: stopManager.getStopNameById(destination),
                    passengers: passengerCounts ? passengerCounts : { adults: 1 },
                    outboundDate: departureTime ? dayjs(departureTime) : dayjs(),
                    inboundDate: arrivalTime ? dayjs(arrivalTime) : null,
                    fromShuttle: fromShuttle || false,
                    toShuttle: toShuttle || false
                });
            }

        } catch (error) {
            console.error("Error in UpdateSearchDataForResumeAction:", error);
        }
    }
}

export const updateSearchDataForResumeAction = new UpdateSearchDataForResumeAction(); 